import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { Button, Input } from "@mui/joy";
import dayjs from "dayjs";
import IconButton from "@mui/joy/IconButton";
import Table from "@mui/joy/Table";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "../../css/sqList.css";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(props.initialOpen || false);

  return (
    <React.Fragment>
      <tr
        style={{
          backgroundColor: row.releaseDate !== null ? "#F4AB6A" : "transparent",
        }}
      >
        <td>
          <IconButton
            aria-label="expand row"
            variant="plain"
            color="neutral"
            size="sm"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </td>
        <td>{row.mawb}</td>
        <td>{row.hawb}</td>
        <td>{row.cargoNo}</td>
        <td>{row.assignCode}</td>
        <td>{row.holdType}</td>
        <td>{row.holdDate}</td>
        <td>{row.releaseDate}</td>
        <td>{row.mfstPackage}</td>
        <td>{row.holdRemark}</td>
        <td>{row.releaseRemark}</td>
        <td>{row.expressFlag}</td>
        <td>{row.terminalCode}</td>
      </tr>
      <tr>
        <td style={{ height: 0, padding: 0 }} colSpan={13}>
          {open && (
            <Sheet
              variant="soft"
              sx={{
                p: 1,
                pl: 6,
                boxShadow: "inset 0 3px 6px 0 rgba(0 0 0 / 0.08)",
                width: "85%",
              }}
            >
              <Typography level="body-lg" component="div">
                History
              </Typography>
              <Table
                borderAxis="bothBetween"
                size="sm"
                aria-label="purchases"
                sx={{
                  "& > thead > tr > th:nth-child(n + 1), & > tbody > tr > td:nth-child(n + 1)":
                    { textAlign: "center" },
                  "--TableCell-paddingX": "0.5rem",
                }}
              >
                <thead>
                  <tr>
                    <th>편명</th>
                    <th>입항날짜</th>
                    <th>MAWB</th>
                    <th>HAWB</th>
                    <th>MRN</th>
                    <th>일시</th>
                    <th>수량</th>
                    <th>등록자</th>
                  </tr>
                </thead>
                <tbody>
                  {row.sqDetail.map((historyRow) => (
                    <tr key={historyRow.cargoSid}>
                      <td>{historyRow.fltNo}</td>
                      <td>{historyRow.fltDate}</td>
                      <td>{historyRow.mawb}</td>
                      <td>{historyRow.hawb}</td>
                      <td>{historyRow.cargoNo}</td>
                      <td>{historyRow.ovcdTime}</td>
                      <td>{historyRow.ovcdPackage}</td>
                      <td>{historyRow.ovcdUserId}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Sheet>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
}

export default function HoldList() {
  const apiUrl = process.env.REACT_APP_APISQ;
  const [start, setStart] = useState(dayjs().subtract(1, "days"));
  const [end, setEnd] = useState(dayjs());
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const filteredData = data.filter((item) =>
    Object.values(item).some(
      (value) =>
        value !== null &&
        value !== undefined &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const search = async () => {
    const startDate = dayjs(start).format("YYYYMMDD");
    const endDate = dayjs(end).format("YYYYMMDD");
    try {
      const response = await fetch(
        `${apiUrl}/sq/search?start=${startDate}&end=${endDate}&carrierCode=${sessionStorage.getItem(
          "carrierCode"
        )}`
      );
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const res = await response.json();

      if (res.length === 0) {
        // 처리할 내용이 있다면 여기에 추가
        alert("DATA가 없습니다.");
      } else {
        const searchData = res.map((row) => ({
          id: row.sid,
          terminalCode: row.terminalCode,
          fltNo: row.fltNo,
          fltDate: row.fltDate,
          cargoNo: row.cargoNo.slice(0, -8),
          mawb: row.mawb,
          hawb: row.hawb,
          assignCode: row.assignCode,
          holdType: row.holdType,
          holdDate: row.holdDate,
          releaseDate: row.releaseDate,
          mfstPackage: row.mfstPackage,
          holdRemark: row.holdRemark,
          releaseRemark: row.releaseRemark,
          expressFlag: row.expressFlag,
          sqDetail: row.sqDetail.map((rows) => ({
            cargoSid: rows.cargoSid,
            fltNo: rows.fltNo,
            fltDate: rows.fltDate,
            mawb: rows.mawb,
            hawb: rows.hawb,
            cargoNo: rows.cargoNo.slice(0, -8),
            ovcdTime: rows.ovcdTime,
            ovcdPackage: rows.ovcdPackage,
            ovcdUserId: rows.ovcdUserId,
          })),
        }));
        setData(searchData);
      }
    } catch (error) {
      console.error("Error in liveFirstData:", error);
    }
  };
  return (
    <Box sx={{ backgroundColor: "#f8f9fa", p: 0.5, m: 1 }}>
      <Box
        sx={{
          p: 0.5,

          pb: 0,
        }}
      >
        <Box
          sx={{
            p: 0.5,
            pb: 0,
            display: "flex",
            marginBottom: 1.5,
          }}
        >
          <Box sx={{ height: 36 }}>
            <Input
              size="md"
              placeholder="Search...."
              variant="soft"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          <Box
            sx={{
              marginLeft: "auto",
              marginRight: 3,
              height: 36,
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="YYYY-MM-DD"
                slots={{ openPickerIcon: FlightTakeoffIcon }}
                slotProps={{ textField: { size: "small" } }}
                sx={{ width: "200px" }}
                value={start}
                onChange={(newValue) => {
                  setStart(newValue);
                }}
              />
            </LocalizationProvider>{" "}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="YYYY-MM-DD"
                slots={{ openPickerIcon: FlightTakeoffIcon }}
                slotProps={{ textField: { size: "small" } }}
                sx={{ width: "200px" }}
                value={end}
                onChange={(newValue) => {
                  setEnd(newValue);
                }}
              />
            </LocalizationProvider>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                search();
              }}
              sx={{ marginTop: 0.3, marginLeft: 1 }}
              variant="plain"
            >
              조 회
            </Button>
          </Box>
        </Box>
        <Box>
          <Table
            aria-label="collapsible table"
            sx={{
              "& > thead > tr > th:nth-child(n + 2), & > tbody > tr > td:nth-child(n + 2)":
                { textAlign: "center", fontSize: "12px" },
              '& > tbody > tr:nth-child(odd) > td, & > tbody > tr:nth-child(odd) > th[scope="row"]':
                {
                  borderBottom: 0,
                },
            }}
          >
            <thead>
              <tr>
                <th style={{ width: 40 }} aria-label="empty" />
                <th>MAWB</th>
                <th>HAWB</th>
                <th>MRN</th>
                <th>배정장소</th>
                <th>보류유형</th>
                <th>보류일시</th>
                <th>해제일시</th>
                <th>적하수량</th>
                <th>이례내용</th>
                <th>해제내용</th>
                <th>특송여부</th>
                <th>터미널</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <Row key={index} row={row} />
              ))}
            </tbody>
          </Table>
        </Box>
      </Box>
    </Box>
  );
}
